module.exports = __webpack_public_path__ + "img/dt.8dbf511c.jpg";